// src/components/Dashboard.js
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/App.css'; // Import the consolidated App.css

function Dashboard() {
  // Mock user
  const user = { name: 'Skyler', role: 'trainer' };

  return (
    <main className="dashboard-page page-wrap">
      <h1>Welcome, {user.name}!</h1>

      {user.role === 'trainer' && (
        <section className="trainer-dashboard">
          <h2 className="text-teal mb-3">Trainer Dashboard</h2>
          <p>
            Check on your clients, assign new workouts, and track 
            their improvements in real time.
          </p>
        </section>
      )}

      {user.role === 'team' && (
        <section className="team-hub">
          <h2 className="text-teal mb-3">Team Hub</h2>
          <p>Manage rosters, analyze performance, and keep the entire squad in sync.</p>
        </section>
      )}

      {user.role === 'clinic' && (
        <section className="clinic-control">
          <h2 className="text-teal mb-3">Clinic Control</h2>
          <p>
            Oversee rehab progress, optimize care, and maintain 
            a data-driven approach to healing.
          </p>
        </section>
      )}
    </main>
  );
}

export default Dashboard;
